import type { CountryConfigMap } from '../auth-config-types'

export const productionConfig: CountryConfigMap = {
	US: {
		en: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority: 'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_SeamlessMigration_SignUpOrSignIn',
			mapPolicy: 'B2C_1A_SeamlessMigration_SignUpOrSignIn',
			mapClientId: '43b9895e-a54a-412e-b11d-eaf11dac570d',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountMissingInfoURL: '',
				MyAccountVehicleURL: '/ownercenter/api/garagesummary',
				NotificationInboxURL: '/notif/delivery/inbox/v1/customer',
				logoutURL: location.origin,
			},
		},
	},
	UK: {
		en: {
			mapTenant: 'gmb2ceuprod.b2clogin.com',
			mapAuthority:
				'https://gmb2ceuprod.b2clogin.com/gmb2ceuprod.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb',
			mapAuthScopes: ['openid', 'profile', '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb'],
			mapApprovedAuthorities: ['gmb2ceuprod.b2clogin.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/uk-en',
			urls: {
				MyAccountProfileURL: '/uk-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/uk-en',
			},
		},
	},
	CA: {
		en: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority: 'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_SeamlessMigration_SignUpOrSignIn',
			mapPolicy: 'B2C_1A_SeamlessMigration_SignUpOrSignIn',
			mapClientId: '43b9895e-a54a-412e-b11d-eaf11dac570d',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/en',
			urls: {
				MyAccountProfileURL: '/en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '/en/ownercenter/api/garagesummary',
				MyAccountMissingInfoURL: '/en/ownercenter/api/checkMissingInfo',
				NotificationInboxURL: '/en/notif/delivery/inbox/v1/customer',
				logoutURL: location.origin + '/en',
			},
		},
		fr: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority: 'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_SeamlessMigration_SignUpOrSignIn',
			mapPolicy: 'B2C_1A_SeamlessMigration_SignUpOrSignIn',
			mapClientId: '43b9895e-a54a-412e-b11d-eaf11dac570d',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/fr',
			urls: {
				MyAccountProfileURL: '/fr/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '/fr/ownercenter/api/garagesummary',
				MyAccountMissingInfoURL: '/fr/ownercenter/api/checkMissingInfo',
				NotificationInboxURL: '/fr/notif/delivery/inbox/v1/customer',
				logoutURL: location.origin + '/fr',
			},
		},
	},
	MX: {
		es: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority: 'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_SeamlessMigration_SignUpOrSignIn',
			mapPolicy: 'B2C_1A_SeamlessMigration_SignUpOrSignIn',
			mapClientId: '19144e1e-0456-4333-831b-713c7176ce45',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin,
			},
		},
	},
	BR: {
		pt: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority: 'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapClientId: 'c12ea0f6-7076-43e1-b973-7bb87598eb1f',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin,
			},
		},
	},
	AR: {
		es: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority: 'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapClientId: '09e2e76f-ed1d-4b44-97f3-796a20c80e65',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/',
			},
		},
	},
	CL: {
		es: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority: 'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapClientId: 'c8994284-98cf-4ab1-8c0c-ac716c2c1094',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/',
			},
		},
	},
	CO: {
		es: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority: 'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapClientId: '49241a0f-d5c1-41c0-849b-314b71e7c499',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/',
			},
		},
	},
	EC: {
		es: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority: 'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapClientId: '9d354784-18c8-465e-a003-8a47721ddd2d',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/',
			},
		},
	},
	PY: {
		es: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority: 'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapClientId: '79bba7fc-2b09-4a53-81d0-cd899a9983a6',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/',
			},
		},
	},
	PE: {
		es: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority: 'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapClientId: 'aa64bb72-9e03-4322-a0b9-bfa0e7599034',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/',
			},
		},
	},
	UY: {
		es: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority: 'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapClientId: 'da4a7732-cea5-44ba-851d-954cdee93272',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/',
			},
		},
	},
	CH: {
		en: {
			mapTenant: 'gmb2ceuprod.b2clogin.com',
			mapAuthority:
				'https://gmb2ceuprod.b2clogin.com/gmb2ceuprod.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb',
			mapAuthScopes: ['openid', 'profile', '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb'],
			mapApprovedAuthorities: ['gmb2ceuprod.b2clogin.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/ch-en',
			urls: {
				MyAccountProfileURL: '/ch-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/ch-en',
			},
		},
		fr: {
			mapTenant: 'gmb2ceuprod.b2clogin.com',
			mapAuthority:
				'https://gmb2ceuprod.b2clogin.com/gmb2ceuprod.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb',
			mapAuthScopes: ['openid', 'profile', '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb'],
			mapApprovedAuthorities: ['gmb2ceuprod.b2clogin.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/ch-fr',
			urls: {
				MyAccountProfileURL: '/ch-fr/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/ch-fr',
			},
		},
		de: {
			mapTenant: 'gmb2ceuprod.b2clogin.com',
			mapAuthority:
				'https://gmb2ceuprod.b2clogin.com/gmb2ceuprod.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb',
			mapAuthScopes: ['openid', 'profile', '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb'],
			mapApprovedAuthorities: ['gmb2ceuprod.b2clogin.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/ch-de',
			urls: {
				MyAccountProfileURL: '/ch-de/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/ch-de',
			},
		},
	},
	DE: {
		en: {
			mapTenant: 'gmb2ceuprod.b2clogin.com',
			mapAuthority:
				'https://gmb2ceuprod.b2clogin.com/gmb2ceuprod.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb',
			mapAuthScopes: ['openid', 'profile', '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb'],
			mapApprovedAuthorities: ['gmb2ceuprod.b2clogin.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/de-en',
			urls: {
				MyAccountProfileURL: '/de-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/de-en',
			},
		},
		de: {
			mapTenant: 'gmb2ceuprod.b2clogin.com',
			mapAuthority:
				'https://gmb2ceuprod.b2clogin.com/gmb2ceuprod.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb',
			mapAuthScopes: ['openid', 'profile', '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb'],
			mapApprovedAuthorities: ['gmb2ceuprod.b2clogin.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/de-de',
			urls: {
				MyAccountProfileURL: '/de-de/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/de-de',
			},
		},
	},
	EU: {
		en: {
			mapTenant: 'gmb2ceuprod.b2clogin.com',
			mapAuthority:
				'https://gmb2ceuprod.b2clogin.com/gmb2ceuprod.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb',
			mapAuthScopes: ['openid', 'profile', '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb'],
			mapApprovedAuthorities: ['gmb2ceuprod.b2clogin.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/eu-en',
			urls: {
				MyAccountProfileURL: '/eu-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/eu-en',
			},
		},
	},
	FR: {
		en: {
			mapTenant: 'gmb2ceuprod.b2clogin.com',
			mapAuthority:
				'https://gmb2ceuprod.b2clogin.com/gmb2ceuprod.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb',
			mapAuthScopes: ['openid', 'profile', '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb'],
			mapApprovedAuthorities: ['gmb2ceuprod.b2clogin.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/fr-en',
			urls: {
				MyAccountProfileURL: '/fr-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/fr-en',
			},
		},
		fr: {
			mapTenant: 'gmb2ceuprod.b2clogin.com',
			mapAuthority:
				'https://gmb2ceuprod.b2clogin.com/gmb2ceuprod.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb',
			mapAuthScopes: ['openid', 'profile', '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb'],
			mapApprovedAuthorities: ['gmb2ceuprod.b2clogin.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/fr-fr',
			urls: {
				MyAccountProfileURL: '/fr-fr/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/fr-fr',
			},
		},
	},
	SE: {
		en: {
			mapTenant: 'gmb2ceuprod.b2clogin.com',
			mapAuthority:
				'https://gmb2ceuprod.b2clogin.com/gmb2ceuprod.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb',
			mapAuthScopes: ['openid', 'profile', '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb'],
			mapApprovedAuthorities: ['gmb2ceuprod.b2clogin.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/se-en',
			urls: {
				MyAccountProfileURL: '/se-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/se-en',
			},
		},
		sv: {
			mapTenant: 'gmb2ceuprod.b2clogin.com',
			mapAuthority:
				'https://gmb2ceuprod.b2clogin.com/gmb2ceuprod.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb',
			mapAuthScopes: ['openid', 'profile', '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb'],
			mapApprovedAuthorities: ['gmb2ceuprod.b2clogin.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/se-sv',
			urls: {
				MyAccountProfileURL: '/se-sv/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/se-sv',
			},
		},
	},
	KR: {
		ko: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority:
				'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/b2c_1a_sk_seamlessmigration_signuporsignin',
			mapPolicy: 'b2c_1a_sk_seamlessmigration_signuporsignin',
			mapClientId: 'fda9cb4b-a06d-48fd-86a7-cecaf98251e3',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '/ownercenter/api/garagesummary',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '/notif/delivery/inbox/v1/customer',
				KoreanProfileRefreshURL: '/bypass/korea/quantum/member/login-refresh.gm',
				KoreanCheckJsonURL: '/bypass/korea/quantum/member/ChkLoginJson.gm',
				logoutURL: location.origin,
			},
		},
	},
	JP: {
		ja: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority: 'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_ANZ_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_ANZ_SIGNUPORSIGNIN',
			mapClientId: '5a633e95-1b6a-4de0-be2b-b1590e82af53',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '/ownercenter/api/garagesummary',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '/notif/delivery/inbox/v1/customer',
				logoutURL: location.origin,
			},
		},
	},
	NZ: {
		en: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority: 'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_ANZ_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_ANZ_SIGNUPORSIGNIN',
			mapClientId: '5a633e95-1b6a-4de0-be2b-b1590e82af53',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/nz-en',
			urls: {
				MyAccountProfileURL: '/nz-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/nz-en',
			},
		},
	},
	AU: {
		en: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority: 'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_ANZ_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_ANZ_SIGNUPORSIGNIN',
			mapClientId: '5a633e95-1b6a-4de0-be2b-b1590e82af53',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/au-en',
			urls: {
				MyAccountProfileURL: '/au-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/au-en',
			},
		},
	},
	NO: {
		en: {
			mapTenant: 'gmb2ceuprod.b2clogin.com',
			mapAuthority:
				'https://gmb2ceuprod.b2clogin.com/gmb2ceuprod.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb',
			mapAuthScopes: ['openid', 'profile', '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb'],
			mapApprovedAuthorities: ['gmb2ceuprod.b2clogin.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/no-en',
			urls: {
				MyAccountProfileURL: '/no-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/no-en',
			},
		},
		no: {
			mapTenant: 'gmb2ceuprod.b2clogin.com',
			mapAuthority:
				'https://gmb2ceuprod.b2clogin.com/gmb2ceuprod.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb',
			mapAuthScopes: ['openid', 'profile', '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb'],
			mapApprovedAuthorities: ['gmb2ceuprod.b2clogin.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/no-no',
			urls: {
				MyAccountProfileURL: '/no-no/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/no-no',
			},
		},
	},
	GB: {
		en: {
			mapTenant: 'gmb2ceuprod.b2clogin.com',
			mapAuthority:
				'https://gmb2ceuprod.b2clogin.com/gmb2ceuprod.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb',
			mapAuthScopes: ['openid', 'profile', '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb'],
			mapApprovedAuthorities: ['gmb2ceuprod.b2clogin.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/gb-en',
			urls: {
				MyAccountProfileURL: '/gb-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/gb-en',
			},
		},
	},
	IE: {
		en: {
			mapTenant: 'gmb2ceuprod.b2clogin.com',
			mapAuthority:
				'https://gmb2ceuprod.b2clogin.com/gmb2ceuprod.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb',
			mapAuthScopes: ['openid', 'profile', '5420a4ae-6e73-4e1e-b29d-efadcb7aa8cb'],
			mapApprovedAuthorities: ['gmb2ceuprod.b2clogin.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/ie-en',
			urls: {
				MyAccountProfileURL: '/ie-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/ie-en',
			},
		},
	},
	OM: {
		en: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority:
				'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '6e919a7b-c638-4739-8a64-08d3fef17bfd',
			mapAuthScopes: ['openid', 'profile', '6e919a7b-c638-4739-8a64-08d3fef17bfd'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/om-en',
			urls: {
				MyAccountProfileURL: '/om-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/om-en',
			},
		},
		ar: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority:
				'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '6e919a7b-c638-4739-8a64-08d3fef17bfd',
			mapAuthScopes: ['openid', 'profile', '6e919a7b-c638-4739-8a64-08d3fef17bfd'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/om-ar',
			urls: {
				MyAccountProfileURL: '/om-ar/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/om-ar',
			},
		},
	},
	BH: {
		en: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority:
				'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '6e919a7b-c638-4739-8a64-08d3fef17bfd',
			mapAuthScopes: ['openid', 'profile', '6e919a7b-c638-4739-8a64-08d3fef17bfd'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/bh-en',
			urls: {
				MyAccountProfileURL: '/bh-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/bh-en',
			},
		},
		ar: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority:
				'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '6e919a7b-c638-4739-8a64-08d3fef17bfd',
			mapAuthScopes: ['openid', 'profile', '6e919a7b-c638-4739-8a64-08d3fef17bfd'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/bh-ar',
			urls: {
				MyAccountProfileURL: '/bh-ar/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/bh-ar',
			},
		},
	},
	SA: {
		en: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority:
				'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '6e919a7b-c638-4739-8a64-08d3fef17bfd',
			mapAuthScopes: ['openid', 'profile', '6e919a7b-c638-4739-8a64-08d3fef17bfd'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/sa-en',
			urls: {
				MyAccountProfileURL: '/sa-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/sa-en',
			},
		},
		ar: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority:
				'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '6e919a7b-c638-4739-8a64-08d3fef17bfd',
			mapAuthScopes: ['openid', 'profile', '6e919a7b-c638-4739-8a64-08d3fef17bfd'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/sa-ar',
			urls: {
				MyAccountProfileURL: '/sa-ar/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/sa-ar',
			},
		},
	},
	QA: {
		en: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority:
				'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '6e919a7b-c638-4739-8a64-08d3fef17bfd',
			mapAuthScopes: ['openid', 'profile', '6e919a7b-c638-4739-8a64-08d3fef17bfd'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/qa-en',
			urls: {
				MyAccountProfileURL: '/qa-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/qa-en',
			},
		},
		ar: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority:
				'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '6e919a7b-c638-4739-8a64-08d3fef17bfd',
			mapAuthScopes: ['openid', 'profile', '6e919a7b-c638-4739-8a64-08d3fef17bfd'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/qa-ar',
			urls: {
				MyAccountProfileURL: '/qa-ar/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/qa-ar',
			},
		},
	},
	KW: {
		en: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority:
				'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '6e919a7b-c638-4739-8a64-08d3fef17bfd',
			mapAuthScopes: ['openid', 'profile', '6e919a7b-c638-4739-8a64-08d3fef17bfd'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/kw-en',
			urls: {
				MyAccountProfileURL: '/kw-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/kw-en',
			},
		},
		ar: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority:
				'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '6e919a7b-c638-4739-8a64-08d3fef17bfd',
			mapAuthScopes: ['openid', 'profile', '6e919a7b-c638-4739-8a64-08d3fef17bfd'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/kw-ar',
			urls: {
				MyAccountProfileURL: '/kw-ar/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/kw-ar',
			},
		},
	},
	AE: {
		en: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority:
				'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '6e919a7b-c638-4739-8a64-08d3fef17bfd',
			mapAuthScopes: ['openid', 'profile', '6e919a7b-c638-4739-8a64-08d3fef17bfd'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/ae-en',
			urls: {
				MyAccountProfileURL: '/ae-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/ae-en',
			},
		},
		ar: {
			mapTenant: 'custlogin.gm.com',
			mapAuthority:
				'https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '6e919a7b-c638-4739-8a64-08d3fef17bfd',
			mapAuthScopes: ['openid', 'profile', '6e919a7b-c638-4739-8a64-08d3fef17bfd'],
			mapApprovedAuthorities: ['custlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/ae-ar',
			urls: {
				MyAccountProfileURL: '/ae-ar/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/ae-ar',
			},
		},
	},
}
